import { Component } from '@contember/interface'
import { BlockHeadline } from './blockHeadline'

export const BlogArticlesForm = Component(() => (
	<>
		<BlockHeadline />
		<h3>All blog articles will be shown</h3>
	</>
))
